/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Pinned = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 60 60">
      <path d="M0 0H60V60L0 0Z" fill="#0095FF" />
      <g filter="url(#filter0_d_336_479)">
        <path
          d="M44.5 7L46.8574 14.2553H54.4861L48.3143 18.7394L50.6717 25.9947L44.5 21.5106L38.3283 25.9947L40.6857 18.7394L34.5139 14.2553H42.1426L44.5 7Z"
          fill="white" />
      </g>
      <defs>
        <filter
          id="filter0_d_336_479"
          x="29.5139"
          y="2"
          width="29.9722"
          height="28.9947"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_336_479" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_336_479" result="shape" />
        </filter>
      </defs>

    </BaseSvgIcon>
  )
}

export default Pinned
